import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HeroSection from './components/HeroSection';
import ThankYouSection from './components/ThankYouSection';
import Checkout from './components/checkout/Checkout';
import Onboarding from './pages/onboarding/Onboarding';
import Auth from './pages/auth/Auth';
import UserRegistration from './pages/auth/UserRegistration';
import AddProduct from './pages/product/AddProduct';
import ParticlesBackground from './components/ParticlesBackground';
import PresentationPage from './pages/presentation/Presentation';
import LinkFormPage from './pages/LinkFormPage';
import WppRedirect from './pages/WppRedirect';
import PrivacyPolicy from './pages/PrivacyPolicy';
import BemVindo from './pages/BemVindo';
import Teste0306 from './pages/teste/Teste0306';
import './App.css';

function App() {
  // Verificar se o usuário está autenticado
  const isAuthenticated = () => {
    return localStorage.getItem('userData') !== null;
  };

  // Componente para rotas protegidas
  const ProtectedRoute = ({ children }) => {
    if (!isAuthenticated()) {
      return <Navigate to="/auth" replace />;
    }
    return children;
  };

  return (
    <Router>
      <div className="App">
        <ParticlesBackground />
        <Routes>
          <Route path="/" element={<HeroSection />} />
          <Route path="/ty" element={<ThankYouSection />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/register" element={
            <ProtectedRoute>
              <UserRegistration />
            </ProtectedRoute>
          } />
          <Route path="/onboarding" element={
            <ProtectedRoute>
              <Onboarding />
            </ProtectedRoute>
          } />
          <Route path="/novo-produto" element={
            <ProtectedRoute>
              <AddProduct />
            </ProtectedRoute>
          } />
          <Route path="/apresentacao" element={<Navigate to="/apresentacao/1" replace />} />
          <Route path="/apresentacao/:slideNumber" element={<PresentationPage />} />
          <Route path="/link" element={<LinkFormPage />} />
          <Route path="/wpp/:telefone" element={<WppRedirect />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/bemvindo" element={<BemVindo />} />
          <Route path="/teste0306" element={<Teste0306 />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
